/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import UserPreferences from '@ion/core/src/preferences/UserPreferences';
import {BaseMapEnum, Preference} from '../types/types';

/**
 * Returns the BaseMapEnum previously persisted to the UserPreferences API.
 */
export const getDefaultBasemap = (): BaseMapEnum => {
  return UserPreferences.get(Preference.basemap) || BaseMapEnum.osm;
};

/**
 * Persists the given BaseMapEnum to the UserPreferences API
 */
export const setDefaultBasemap = (basemap = BaseMapEnum.osm) => {
  if (basemap) {
    UserPreferences.set(Preference.basemap, basemap, true);
  } else {
    UserPreferences.remove(Preference.basemap, false, true);
  }
};
